export const ROUTE_PATHS = {
  HOME: "/",
  MENU: "/menu",
  ABOUT: "/about",
  LOCATION: "/location",
} as const;

export type MenuCategory = 
  | "Signature Dakgalbi"
  | "Korean Fried Chicken"
  | "Authentic Stews"
  | "Korean Sides"
  | "Refreshments";

export const MENU_CATEGORIES: MenuCategory[] = [
  "Signature Dakgalbi",
  "Korean Fried Chicken",
  "Authentic Stews",
  "Korean Sides",
  "Refreshments",
];

export interface MenuItem {
  id: string;
  name: string;
  description: string;
  price: number;
  category: MenuCategory;
  image: string;
  isSpicy?: boolean;
  isBestSeller?: boolean;
  portionSize?: string;
}

export interface LocationInfo {
  mallName: string;
  address: string;
  unitNumber: string;
  phone: string;
  whatsapp: string;
  operatingHours: {
    weekdays: string;
    weekends: string;
  };
  grabLink: string;
  googleMapsUrl: string;
  landmark: string;
}

export function formatPrice(price: number): string {
  return `RM ${price.toFixed(2)}`;
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");
}
